import React from "react";
import { Chip, withStyles, Box } from "@material-ui/core";

const CustomChip = withStyles(() => ({
  root: {
    display: "inline-block",
    marginTop: "2px",
    textDecoration: "none",
  },
  labelSmall: {
    display: "inline-block",
    lineHeight: 1,
    marginTop: "3px",
  },
}))(Chip);

type Props = {
  label: string;
  chips?: string[] | null;
};

/**
 * A component that is composed of a label and one to many chips
 * @param label - The label displayed
 * @param chips - An array of strings which will display as chips
 * @constructor
 */
export const ChipLabel: React.FC<Props> = ({ label, chips }) => (
  <Box display="flex" flexDirection="row" alignItems="center">
    <Box component="span" lineHeight={1}>
      {label}
    </Box>
    {(chips || []).map((chip, i) => (
      <Box ml={1} key={`${chip}-i`}>
        <CustomChip label={chip} size="small" variant="outlined" />
      </Box>
    ))}
  </Box>
);
